import { render } from "./dataset-detail.component.vue?vue&type=template&id=13f66847&scoped=true&ts=true"
import script from "./dataset-detail.component.vue?vue&type=script&lang=ts"
export * from "./dataset-detail.component.vue?vue&type=script&lang=ts"

import "./dataset-detail.component.vue?vue&type=style&index=0&id=13f66847&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f66847"]])

export default __exports__